const getTypeValue = () => {
    return [
        { value: "1", text: "$" }, //Valor
        { value: "2", text: "%" }, //Porcentaje
    ]
}


export default getTypeValue;